import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((_theme) => ({
  descriptionSection: {
    marginTop: '40px',
  },
  descriptionText: {
    marginTop: '2em',
  },
  agreementBox: {
    marginTop: '40px',
  },
  agreementBoxSectionContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    border: '1px solid #ccc',
    padding: '20px',
    marginBottom: '40px',
    minHeight: '90px',
  },
  agreementRequired: {
    float: 'right',
  },
}))
